<div [formGroup]="form">
    @if (!project?.id && types.length > 1) {
        <mat-form-field class="w-100">
            <mat-placeholder>Soort project</mat-placeholder>
            <mat-select [formControl]="fc.type" (selectionChange)="loadTemplates($event.value)">
                @for (status of types; track status.key) {
                    <mat-option [value]="status.key">
                        {{ status.name }}
                    </mat-option>
                }
            </mat-select>
            <mat-error [control]="fc.type"></mat-error>
        </mat-form-field>
    }
    @if (fc.type.value) {
        @if (fc.type.value !== 'drillings' && projectTemplates?.length) {
            <mat-form-field class="w-100">
                <mat-placeholder>Project template</mat-placeholder>
                <mat-select [formControl]="fc.template" (selectionChange)="applyTemplate($event.value)">
                    <mat-option [value]="null"> Geen template </mat-option>
                    @for (template of projectTemplates; track template.id) {
                        <mat-option [value]="template.id">
                            {{ template.name }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        }
        <mat-form-field class="w-100">
            <mat-placeholder>Naam</mat-placeholder>
            <input formControlName="name" matInput type="text" />
            <mat-error [control]="fc.name"></mat-error>
        </mat-form-field>
        <mat-form-field class="w-100">
            <mat-placeholder>Budget</mat-placeholder>
            <input appDecimalInput formControlName="budget" matInput type="text" />
            <mat-error [control]="fc.budget"></mat-error>
        </mat-form-field>
        @if (fc.type.value !== 'drillings') {
            <div>
                <mat-checkbox class="mt-1 mb-1" color="primary" formControlName="custom_numbers">
                    Eigen nummerreeks
                </mat-checkbox>
            </div>
            <div>
                <mat-checkbox class="mt-1 mb-1" color="primary" formControlName="consumers">
                    Openstellen voor bewoners
                </mat-checkbox>
            </div>
            @if (fc.consumers.value) {
                <div>
                    <mat-checkbox class="mt-1 mb-1" color="primary" formControlName="consumers_site">
                        Zichtbaar op website
                    </mat-checkbox>
                </div>
            }
            <div>
                <mat-checkbox class="mt-1 mb-1" color="primary" formControlName="archive"> Archiveren </mat-checkbox>
            </div>
            <div>
                <mat-checkbox class="mt-1 mb-3" color="primary" formControlName="email">
                    E-mailupdates versturen
                </mat-checkbox>
            </div>
        }
        <mat-form-field class="w-100">
            <mat-placeholder>Projectleider</mat-placeholder>
            <mat-select formControlName="manager">
                @for (user of managers; track user.id) {
                    <mat-option [value]="user.id">
                        {{ user.name }}
                    </mat-option>
                }
            </mat-select>
            <mat-error [control]="fc.manager"></mat-error>
        </mat-form-field>
        @if (fc.type.value !== 'drillings') {
            <mat-form-field class="w-100">
                <mat-placeholder>Externe opdrachtgever</mat-placeholder>
                <mat-select formControlName="customer_manager">
                    @for (user of customers; track user.id) {
                        <mat-option [value]="user.id">
                            {{ user.name }}
                        </mat-option>
                    }
                </mat-select>
                <mat-error [control]="fc.customer_manager"></mat-error>
            </mat-form-field>
        }
        @if (fc.type.value === 'maintenance') {
            <mat-checkbox class="mt-2 mb-1" color="primary" formControlName="appendAllCurrentParts">
                Alle bestaande delen toevoegen
            </mat-checkbox>
        }
    }
</div>
